import $ from "jquery";
import { checkNested, getConfig, createGuid, getMeta, getDynData, testDynData, getDynDataOne, articlesExtend } from "./general_functions";
import { getImageByContentId } from "./images";
import language from "./translation";

export const setCampaign = () => {



    $.getJSON(window.apiUrl + `/api/PublicContentApi/getcontentlistdescending/${client.clientId}/mal_dynamisk/100/0/Modified`).done((result) => {


        let campaignsList = [];
        let campaigns = [];
        let campCount = 0;

        result.listOfContent.forEach(campaign => {
            campaign = articlesExtend(campaign);
            let meta = getMeta(campaign);
            let details = getDynData(meta);
            // let campGuid = createGuid();
            campaign.title = details.forsidetittel || campaign.title
            const templateId = checkNested(campaign, 'metaParsed', 'contentTypeId') ? campaign.metaParsed.contentTypeId : campaign.metaParsed.id;
            let isCampaign = templateId == "4e159a34-1e45-413f-b053-a2bd9f843121";
            if (isCampaign) {
                campaignsList.push(campaign);
            }
        });

        let nofCamp = campaignsList.length <= 3 ? campaignsList.length : 3;

        campaignsList.forEach(campaign => {
            let campGuid = createGuid();
            let campTitle = campaign.title
            let meta = getMeta(campaign);
            let details = getDynData(meta);

            if (campCount < 3 && campTitle) {
                let image = ``;
                //if(details.image)
                let hasImage = false;
                let cloudinaryUrl = "";

                if (meta.imageContentId) {
                    hasImage = true;
                    image = `<div class="campaign__image_container"><img src='' id='campaign__${campGuid}' class="campaign__image" desc="${meta.imageDescription}" alt="${meta.imageDescription}"></div>`;
                    getImageByContentId(meta.imageContentId, (img) => {

                        //console.log(img);
                        //set size depending on desktop/mobile view
                        if ($(document).width() < 768) {
                            //Mobile view
                            cloudinaryUrl = "https://res.cloudinary.com/ssp/image/fetch/g_center,w_315,h_180,c_fill,f_webp/" + img.url;
                        }
                        else {
                            //Desktop view
                            if (nofCamp >= 3) {
                                cloudinaryUrl = "https://res.cloudinary.com/ssp/image/fetch/g_center,w_305,h_180,c_fill,f_webp/" + img.url;
                            }
                            else {
                                cloudinaryUrl = "https://res.cloudinary.com/ssp/image/fetch/g_center,w_180,h_180,c_fill,f_webp/" + img.url;
                            }
                        }
                        $(`#campaign__${campGuid}`).attr("src", cloudinaryUrl);
                    });
                }


                let link = `/artikkel/${campaign.contentId}`;
                let linktext = "Les mer her";

                let dynLink = getDynData(meta, "dddc6cac-9579-4d59-9f52-c3a85ca05473").res;

                if (dynLink) {
                    link = dynLink; //`<span class="campaign__link">Gå til siden</span>`;
                    linktext = language("CAMPAIGN_GOTOPAGE");
                }

                //

                campCount++;
                let campWidths = [12, 6, 4];

                let CampContent = {
                    link: link,
                    image: image,
                    title: campTitle,
                    tekst: details.forsidetekst,
                    linktext: linktext,
                    cols: campWidths[nofCamp - 1]
                };
                if (nofCamp < 3) {
                    campaigns.push(compaign_template(CampContent));
                }
                else {
                    campaigns.push(compaign_3col_template(CampContent));
                }
                // campaigns.push(`
                // <div class="col-12 col-md-${campWidths[nofCamp-1]} d-flex align-items-stretch">
                //     <a class="campaign__item position-relative" href="${link}">
                //         <div class="row">
                //             ${image}
                //             <div class="${nofCamp<3?`col`:`col-12 pt-5`}">
                //                 <h2 class="campaign__title">${campTitle}</h2>
                //                 <p class="campaign__text">${details.forsidetekst}</p>
                //                 ${nofCamp<3?`<span class="campaign__link">`+linktext+`</span>`:``}
                //             </div>      
                //         </div>
                //         ${nofCamp<3?``:`<span class="campaign__link mb-5">`+linktext+`</span>`}
                //     </a>
                // </div>
                // `);
            }

        });

        if (campaigns.length < 1) {
            $("#campaigns").html("");
        }
        else {

            campaigns = campaigns.join("");
            $("#campaigns").html(campaigns);

        }


    }).fail(function() {

        $("#campaigns").html("");

    });


    return `
        <div class="col text-center mt-5">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading ...</span>
            </div>
        </div>
        
    `;

}

export const compaign_template = (content) => {
    return `
        <div class="col-12 col-md-${content.cols} d-flex align-items-stretch">
            <a class="campaign__item" href="${content.link}">
                <div class="row">
                    ${content.image}
                    <div class="col">
                        <h2 class="campaign__title">${content.title}</h2>
                        <p class="campaign__text">${content.tekst}</p>
                        <span class="campaign__link">${content.linktext}</span>                       
                    </div>      
                </div>
            </a>
        </div>`
}

export const compaign_3col_template = (content) => {
    return `
        <div class="col-12 col-md-${content.cols} d-flex align-items-stretch">
            <a class="campaign__item position-relative" href="${content.link}">
                <div class="row">
                    ${content.image}
                    <div class="col-12 pt-5">
                        <h2 class="campaign__title">${content.title}</h2>
                        <p class="campaign__text">${content.tekst}</p>                   
                    </div>  
                </div>
                <span class="campaign__link mb-5">${content.linktext}</span>
            </a>
        </div>`
}
